<div class="tpl--static__header">
    <wep-tpl-static-heading>
    </wep-tpl-static-heading>
</div>
<div class="tpl--static__body">
        <div class="tpl--static__container">
            <router-outlet></router-outlet>
        </div>
</div>
<div class="tpl--static__footer">
    <wep-tpl-static-footer>
    </wep-tpl-static-footer>
</div>